import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Upload,
  message
} from "antd";
import React, { useState } from "react";
import MultiSelect from "../../../../../components/common/MultiSelect";
import PageHeading from "../../../../../components/common/PageHeading";
import { BulkChargesData, propertyData } from "./BulkChargesData";
import "./BulkChargesData.css";

const props = {
    name: 'file',
    multiple: true,
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

const BulkChargesAndCredits = () => {
  const [form] = Form.useForm();
  const [glAccountTemplate, setGlAccountTemplate] = useState(0);
  const [isIncludePastTenant, setIsIncludePastTenant] = useState(false);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setGlAccountTemplate(e.target.value);
  };
  const { Dragger } = Upload;
  const handleIncludePastTenants = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setIsIncludePastTenant(e.target.checked);
  };
  return (
    <div className="BulkChargesAndCredits">
      <PageHeading heading="Bulk Charges and Credits" />

      <Card title="Choose a Template">
        <Radio.Group onChange={onChange} value={glAccountTemplate}>
          <Space direction="vertical">
            <Radio value={0}>Single GL Account Template</Radio>
            <Radio value={1}>Multiple GL Accounts Template</Radio>
          </Space>
        </Radio.Group>
        <br />
        <br />
        <p>{BulkChargesData[glAccountTemplate]?.c1title}</p>
        <p>
          <b>{BulkChargesData[glAccountTemplate]?.c1BoldTitle}</b>
        </p>
        <p>{BulkChargesData[glAccountTemplate]?.c1listItem1}</p>
        <p>{BulkChargesData[glAccountTemplate]?.c1listItem2}</p>
        <p>{BulkChargesData[glAccountTemplate]?.c1listItem3}</p>
      </Card>
      <br />
      <Card title="Format and Download Template">
        <p>{BulkChargesData[glAccountTemplate]?.c2Title}</p>
        <br />
        <Form
          form={form}
          name="basic"
          autoComplete="off"
          colon={false}
          layout="vertical"
        >
          <Row>
            <Col span={12}>
              <Form.Item label="Properties" name="searchProperty">
                <MultiSelect
                  options={propertyData}
                  placeholder="Search by property, group, portfolio, or owner"
                />
                <span className="form__row__hint">
                  By default all properties and associations will be included.
                </span>
              </Form.Item>
            </Col>
          </Row>
          {glAccountTemplate === 1 ? (
            <>
              <Checkbox onChange={handleIncludePastTenants}>
                Include past tenants/homeowners
              </Checkbox>
              <br />

              {isIncludePastTenant ? (
                <>
                  <br />
                  <p>
                    Specify dates within which you want to include
                    tenants/homeowners.
                  </p>
                  <br />
                  <Row>
                    <Col span={4}>
                      <Form.Item label="Date Range" name="DateRange" required>
                        <DatePicker style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                    <Col span={1} className="dateRangeTo">
                      <p>to</p>
                    </Col>
                    <Col span={4}>
                      <Form.Item label=" " name="DateRange">
                        <DatePicker style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
          <br />
          <Button>Download Template</Button>
        </Form>
      </Card>
      <br />
      <Card title="Upload Your Charges and Credits">

        <Form layout="vertical">
            {glAccountTemplate === 0 ? 
          <><Row>
                          <Col span={6}>
                              <Form.Item
                                  label="Charges and Credits Date"
                                  name="ChargesandCreditsDate"
                                  required
                              >
                                  <DatePicker style={{ width: "100%" }} />
                              </Form.Item>
                          </Col>
                      </Row><Row>
                              <Col span={6}>
                                  <Form.Item label="Posting Date" name="PostingDate" required>
                                      <DatePicker style={{ width: "100%" }} />
                                  </Form.Item>
                              </Col>
                          </Row><Row>
                              <Col span={12}>
                                  <Form.Item label="GL Account" name="GLAccount" required>
                                      <Select
                                          showSearch
                                          allowClear
                                          placeholder="Start typing to search"
                                          optionFilterProp="children"
                                          filterOption={(input, option) => (option?.label ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())}
                                          options={[
                                              {
                                                  value: "jack",
                                                  label: "Jack",
                                              },
                                              {
                                                  value: "lucy",
                                                  label: "Lucy",
                                              },
                                              {
                                                  value: "tom",
                                                  label: "Tom",
                                              },
                                          ]} />
                                  </Form.Item>
                              </Col>
                          </Row></>
:''}
          <Row>
            <Col span={12}>
              <Form.Item label="Description" name="Description">
                <Input />
                <span className="form__row__hint">
                  Individual descriptions from file will be added to this
                  description.
                </span>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Dragger {...props}>
                <p className="ant-upload-text">Drag File Here</p>
                <p className="ant-upload-text">or</p>
                <p className="ant-upload-hint">
                  <Button>Choose File to Upload</Button>
                </p>
              </Dragger>
            </Col>
          </Row>
          <br />
          <Row gutter={16} style={{marginTop:'12px'}}>
            <Col>
              <Button type="primary">Submit</Button>
            </Col>
            <Col>
              <Button type="link">Cancel</Button>
            </Col>
          </Row>
        </Form>
      </Card>
      
      <div className="RightSidebar">
      </div>
    </div>
  );
};

export default BulkChargesAndCredits;
